import Splide from '@splidejs/splide';

((Drupal) => {
  'use strict';

  const INIT_ATTR = 'data-slider-ready';

  function init(root) {
    if (root.hasAttribute(INIT_ATTR)) return;
    root.setAttribute(INIT_ATTR, '1');

    const columns = parseInt(root.dataset.sliderColumns, 10) || 3;
    const track   = root.querySelector('.splide');
    const prevBtn = root.querySelector('.slider__arrow--prev');
    const nextBtn = root.querySelector('.slider__arrow--next');

    if (!track) return;

    const gap3 = '24px';
    const gap2 = '32px';
    const gap  = columns === 2 ? gap2 : gap3;

    const splide = new Splide(track, {
      type:       'slide',
      perPage:    columns,
      perMove:    1,
      gap:        gap,
      padding:    { right: '21px' },
      arrows:     false,
      pagination: false,
      loop:       false,
      breakpoints: columns === 4 ? {
        // Four-up (portrait covers): 1 / 2 / 3 cards + peek as it narrows.
        575: { perPage: 1, gap: gap, padding: { right: '21px' } },
        767: { perPage: 2, gap: gap, padding: { right: '21px' } },
        991: { perPage: 3, gap: gap, padding: { right: '21px' } },
      } : {
        // < 576px — 1 card + peek
        575: {
          perPage: 1,
          gap:     gap,
          padding: { right: '21px' },
        },
        // 576–991px — 2 cards + peek (3col), 1 card + peek (2col)
        991: {
          perPage: columns === 3 ? 2 : 1,
          gap:     gap,
          padding: { right: '21px' },
        },
      },
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => splide.go('<'));
      nextBtn.addEventListener('click', () => splide.go('>'));

      const updateArrows = () => {
        const index   = splide.index;
        const length  = splide.length;
        const perPage = splide.options.perPage;
        prevBtn.disabled = index === 0;
        nextBtn.disabled = index >= length - perPage;
      };

      splide.on('mounted move', updateArrows);
    }

    splide.mount();
  }

  Drupal.behaviors.kildenSlider = {
    attach(context) {
      context.querySelectorAll('.slider').forEach(init);
    },
  };

})(Drupal);
